import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function CheckOutIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 29.82 29.82">
      <path d="M14.83 15.73a.75.75 0 10-.72-.75.74.74 0 00.72.75z"/>
      <path d="M23.29 11.24l-.91.74 2.13 2.42h-4.37V6.62h-2.3V4.41L7.11 6.84v16.8l10.73 1.77v-1.79h2.3v-8.06h4.37L22.42 18l.91.74L26.54 15zm-6.54 12.83L8.2 22.66V7.77l8.55-1.94zm2.39-1.45h-1.3v-15h1.3z"/>
    </SvgIcon>

  )
}

export default CheckOutIcon
